import { Injectable } from '@angular/core';
import { SearchCharacteristicWithType } from '../../models/models';

/*
  Generated class for the SearchProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class SearchProvider {

  private _allSearchCharacteristics: Array<SearchCharacteristicWithType> = [];
  private timestamp;

  constructor() {
    console.log('Hello SearchProvider Provider');
    this._allSearchCharacteristics = [];
    this.timestamp = Date.now();
  }

  resetSearchParams() {
    this._allSearchCharacteristics = [];
  }

  getSearchParams() {
    return this._allSearchCharacteristics;
  }

  setSearchParams(input: Array<SearchCharacteristicWithType>) {
   //debugger;
    this._allSearchCharacteristics = [];
    this._allSearchCharacteristics = input;
  }

}
